




















import { Component, Vue, Prop } from "vue-property-decorator";
import CloseIcon from "@/assets/icons/CloseIcon.vue";

@Component({
  components: {
    appCloseIcon: CloseIcon
  }
})
export default class Message extends Vue {
  @Prop({
    type: String,
    default: "normal",
    validator: (value: string) =>
      ["normal", "info", "warning", "success", "error"].includes(value)
  })
  readonly type?: string;
}
